import { render, staticRenderFns } from "./WorkDocumentePendingRegistering.vue?vue&type=template&id=495d604d&scoped=true&"
import script from "./WorkDocumentePendingRegistering.ts?vue&type=script&lang=ts&"
export * from "./WorkDocumentePendingRegistering.ts?vue&type=script&lang=ts&"
import style0 from "./WorkDocumentePendingRegistering.vue?vue&type=style&index=0&id=495d604d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495d604d",
  null
  
)

export default component.exports
import {QTable,QSpace,QInput,QIcon,QCard,QCardSection,QSeparator,QBtn,QMenu,QTr,QTd} from 'quasar'
component.options.components = Object.assign({QTable,QSpace,QInput,QIcon,QCard,QCardSection,QSeparator,QBtn,QMenu,QTr,QTd}, component.options.components || {})
